export const en = {
  donation: {
    donation_details: "Donation Details",
    donation_type: "One Time or Recurring Gift",
    donation_type_frequency: "* Giving Frequency",
    daily: "Daily",
    weekly: "Weekly",
    biweekly: "Bi-Weekly",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
    donation_amount: "Gift Amount",
    one_time_donation: "One Time Gift",
    recurring_donation: "Recurring Gift",
    email_address: "Email Address",
    f_name: "First Name",
    l_name: "Last Name",
    message: "Message (optional)",
    fund: "Fund",
    target: "Designation",
    target_description: "Choose which cause you would like your gift to go towards",
    errors: {
      email_req: "Email is required",
      email_invalid: "Please enter a valid email",
      amount_low: "Please enter a minimum gift of ",
      start_date: "Start date is required",
      generic_req: "Required",
      invalid_characters: "Name contains invalid characters"
    },
    actions: {
      next: "Next",
      change: "Change",
      donate: "Give Now",
    },
    messages: {
      loading: "Loading...",
      processing: "Processing Your Donation",
      thanks: "Thank you for your donation",
    },
    frequencyDetails: {
      "week": "* Weekly recurring gifts are processed every week on the renewal date, adjusting for weekends or holidays, as required by banks or credit card processors. " +
        "The renewal date is set based on the same day of the week the gift was set up. For credit card payments, first payments are processed immediately on the renewal date. " +
        "ACH payments may take 1-3 days based on your bank's policies.",
      "biWeek": "* Bi-Weekly recurring gifts are processed every two weeks on the renewal date, adjusting for weekends or holidays, as required by banks or credit card processors. " +
        "The renewal date is set based on the same day of the week the gift was set up. " +
        "For credit card payments, first payments are processed immediately on the renewal date. ACH payments may take 1-3 days based on your bank's policies.",
      "month": "* Monthly recurring gifts are processed every month on the renewal date, adjusting for weekends or holidays, as required by banks or credit card processors. " +
        "Renewal date is set based on the initial gift date or the last day of the month if the renewal date falls on the 31st. " +
        "For credit card payments, first payments are processed immediately on the renewal date. ACH payments may take 1-3 days based on your bank's policies.",
      "quarter": " * Quarterly recurring gifts are processed every third month on the renewal date, adjusting for weekends or holidays, as required by banks or credit card processors. " +
        "Renewal date is set based on the initial gift date or the last day of the month if the renewal date falls on the 31st. " +
        "For credit card payments, first payments are processed immediately on the renewal date. ACH payments may take 1-3 days based on your bank's policies."
    },
    status: {
      'created': 'Created',
      'completed': 'Completed',
      'abandoned': 'Abandoned',
      'error': 'Error',
      'cancelled': 'Canceled',
      'pending': 'Pending',

      'trialing': 'Scheduled',
      'paused': 'Paused',
      'active': 'Active',
      'success': "Success"
    }
  },
  payment: {
    errors: {
      error: "Error!",
      generic_form_error: "Something went wrong loading the payment form. Please refresh the page. If the problem persists, please contact the administrator",
      no_payment_processor: "No payment processor has been configured for this Organization",
      generic_payment_error: "Something went wrong processing your donation. Please try again.",
      payment_failed: "Your payment was declined. Please try a different payment method"
    },
    success: "Thank you, your gift was successfully received. You will now be redirected ...",
    pending: "Thank you, your gift is being processed. You will now be redirected ...",
    trialing: "Thank you, your recurring gift was set up successfully. You will now be redirected ..."
  },
  generic_errors: {
    not_found: "The page you've requested could not be found, please close this page.",
    unauthorized: "You are not authorized to view this page"
  },
  reports: {
    welcome: "Reports",
    selectCategory: "Choose a report type to get started!",
    donors: {
      header: "Donors",
      donor_list: {
        title: "Donor List",
        description: "Exports a list of your donors in a csv file."
      },
      year_end_summary: {
        title: "Year End Summary",
        description: "Exports a summary of gifts for each selected donor for the selected year with a thank you message from your organization. Each thank you summary is a PDF file."
      },
      contribution_statement: {
        title: "Contribution Statement",
        description: "Exports a summary of gifts for each selected donor for the selected year. Each summary is a PDF file."
      },
      giving_trends: {
        title: "Giving Trends",
        description: "Compare donor giving across two periods to identify increases, decreases, lapsed, and new donors."
      }
    },
    donations: {
      header: "Gifts",
      donation_report: {
        title: "Giving Report",
        description: " Generate a report of all gifts to your organization in a csv file."
      },

    },
    households: {
      header: "Households",
      household_giving_summary: {
        title: "Giving Summary",
        description: "Exports a giving summary for each selected household for the selected year. Each summary is a PDF file."
      },
      household_member_list: {
        title: "Member List",
        description: "Exports a list of members for each selected household in a csv file."
      }
    },
    history: {
      header: "History",
      noHistory: "No Reports to show.",
      noHistoryMessage: "Choose an option from the menu to get started!"
    }
  },
  payment_processor: {
    welcome: "Payment Processors",
    selectCategory: "Select a category from the sidebar to get started",
    payment_processor: {
      header: "Payment Processor",
      details:{
        title: "Details"
      }
    },
    documents: {
      header: "Documents",
      submit: {
        title: "Submit"
      },
      history: {
        title: "History"
      }
    }
  },
  admin: {
    panels: {
      overview: "Overview",
      donors: "Donors",
      households: "Households",
      team: "My Team",
      donations: "Gifts",
      funds: "Funds",
      campaigns: "Campaigns",
      payment_processors: "Payment Processors",
      landing_builder: "Design Hub",
      notifications: "Communication Station",
      branding: "Branding",
      reports: "Reporting",
      personal_settings: "Personal Settings",
      organization_settings: "Organization Settings"
    },
    controls: {
      settings: "Settings",
      logout: "Log Out",
      sign_in_message: "Sign in to your account",
      email: "Email Address",
      email_placeholder: "Enter email",
      password: "Password",
      password_placeholder: "Enter password",
      remember_me: "Remember me",
      sign_in: "Sign In"
    }
  },
  organization: {
    valid_states: {
      "AL": "Alabama",
      "AK": "Alaska",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DE": "Delaware",
      "FL": "Florida",
      "GA": "Georgia",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PA": "Pennsylvania",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VA": "Virginia",
      "WA": "Washington",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming",
      // Canadian Provinces
      "AB": "Alberta",
      "BC": "British Columbia",
      "MB": "Manitoba",
      "NB": "New Brunswick",
      "NL": "Newfoundland and Labrador",
      "NS": "Nova Scotia",
      "NT": "Northwest Territories",
      "NU": "Nunavut",
      "ON": "Ontario",
      "PE": "Prince Edward Island",
      "QC": "Quebec",
      "SK": "Saskatchewan",
      "YT": "Yukon",
    },
    time_zones: {
      "America/New_York": "Eastern Time (US & Canada)",
      "America/Detroit": "Eastern Time (US & Canada)",
      "America/Kentucky/Louisville": "Eastern Time (US & Canada)",
      "America/Kentucky/Monticello": "Eastern Time (US & Canada)",
      "America/Indiana/Indianapolis": "Indiana (East)",
      "America/Indiana/Vincennes": "Indiana (East)",
      "America/Indiana/Winamac": "Indiana (East)",
      "America/Indiana/Marengo": "Indiana (East)",
      "America/Indiana/Petersburg": "Indiana (East)",
      "America/Indiana/Vevay": "Indiana (East)",
      "America/Chicago": "Central Time (US & Canada)",
      "America/Indiana/Tell_City": "Central Time (US & Canada)",
      "America/Indiana/Knox": "Central Time (US & Canada)",
      "America/Menominee": "Central Time (US & Canada)",
      "America/North_Dakota/Center": "Central Time (US & Canada)",
      "America/North_Dakota/New_Salem": "Central Time (US & Canada)",
      "America/North_Dakota/Beulah": "Central Time (US & Canada)",
      "America/Denver": "Mountain Time (US & Canada)",
      "America/Boise": "Mountain Time (US & Canada)",
      "America/Phoenix": "Arizona",
      "America/Los_Angeles": "Pacific Time (US & Canada)",
      "America/Anchorage": "Alaska",
      "America/Juneau": "Alaska",
      "America/Sitka": "Alaska",
      "America/Metlakatla": "Alaska",
      "America/Yakutat": "Alaska",
      "America/Nome": "Alaska",
      "America/Adak": "Alaska",
      "Pacific/Honolulu": "Hawaii"
    },
    valid_countries: {
      "United States": "United States",
      "Canada": "Canada"
    },
    org_types: {
      "Church": "Church",
      "Non-Profit": "Non Profit",
      "Educational Institution": "Educational Institution"
    }
  },
  forms: {
    fields: {
      "f_name": "First Name",
      "l_name": "Last Name",
      "email": "Email",
      "role": "Role",
      "designation": "Designation",
      "amount": "Amount",
      "paymentType": "Payment Method",
      "date": "Date",
      "notes": "Notes"
    }
  },
  chart: {
    gifts: "Gifts",
    projected_gifts: "Projected Gifts",
    last_year: "Last Year",
    dollars: "Dollars",
    projected_dollars: "Projected Dollars"
  }
};
